import { render, staticRenderFns } from "./PsNewButton.vue?vue&type=template&id=9c49e47e&scoped=true&"
import script from "./PsNewButton.vue?vue&type=script&lang=js&"
export * from "./PsNewButton.vue?vue&type=script&lang=js&"
import style0 from "./PsNewButton.vue?vue&type=style&index=0&id=9c49e47e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c49e47e",
  null
  
)

export default component.exports